import { render, staticRenderFns } from "./HeaderMessages.vue?vue&type=template&id=18c1ce57&"
import script from "./HeaderMessages.vue?vue&type=script&lang=js&"
export * from "./HeaderMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports